// extracted by mini-css-extract-plugin
export default {"list_item":"ContactListItem_list_item__mLK5h","deleteBtn":"ContactListItem_deleteBtn__roUYm"};